import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Select } from 'components/FormInputs';
import api from 'api';
import { setUserLanguage, showSnackbar } from 'actions';
import * as userSelectors from 'selectors/user';

const options = [
  { label: 'English', value: 'EN' },
  { label: 'Svenska', value: 'SV' },
];

const EMPTY_ERRORS = {};

const ProfileLanguageSelect = () => {
  const dispatch = useDispatch();
  const language = useSelector(userSelectors.lang);
  const inFlightRef = React.useRef(false);
  const mountedRef = React.useRef(true);
  const [pending, setPending] = React.useState(null);

  React.useEffect(
    () => () => {
      mountedRef.current = false;
    },
    [],
  );

  const displayed = pending ?? language ?? '';

  const handleChange = async (e) => {
    const next = e.target.value;
    if (!next || next === displayed || inFlightRef.current) return;

    inFlightRef.current = true;
    setPending(next);
    try {
      await api.changeLanguage(next);
      dispatch(setUserLanguage(next));
      dispatch(
        showSnackbar({
          severity: 'success',
          message: {
            id: 'profile.language.updated',
            defaultMessage: 'The language has been updated',
          },
        }),
      );
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to change language:', err);
      dispatch(
        showSnackbar({
          severity: 'error',
          message: {
            id: 'profile.language.updateFailed',
            defaultMessage: 'Could not update language. Please try again.',
          },
        }),
      );
    } finally {
      inFlightRef.current = false;
      if (mountedRef.current) setPending(null);
    }
  };

  return (
    <Select
      name="language"
      value={displayed}
      onChange={handleChange}
      errors={EMPTY_ERRORS}
      label={<FormattedMessage id="userform.language" defaultMessage="Language" />}
      required
      options={options}
    />
  );
};

export default ProfileLanguageSelect;
